import getTextAlignment from "helpers/getTextAlignment";
import { CSSProperties } from "react";

export default (settings: any, styles: any): any => {
    const style: CSSProperties = {};
    const classes: string[] = [];

    if (settings?.controlsColor) {
        style["--cards-controls-color"] = settings?.controlsColor;
    }

    if (settings?.scrollbarColor) {
        style["--cards-scrollbar-color"] = settings.scrollbarColor;
    }

    if (settings?.scrollbarHandleColor) {
        style["--cards-scrollbar-handle-color"] = settings.scrollbarHandleColor;
    }

    if (settings?.cardHeadingAlignment) {
        style["--headline-alignment"] = getTextAlignment(settings?.cardHeadingAlignment);
    }

    if (settings?.cardTextAlignment) {
        style["--text-alignment"] = getTextAlignment(settings?.cardTextAlignment);
    }

    return {
        containerStyles: style,
        containerClasses: classes
    };
};